export type DayKey =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday';

export interface WorkingHoursDay {
  enabled: boolean;
  start: string;
  end: string;
}

export interface WorkingHoursConfig {
  timezone: string;
  schedule: Record<DayKey, WorkingHoursDay>;
}

export const DAY_LABELS: Record<DayKey, string> = {
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
};

const defaultDay = (enabled: boolean, start = '08:00', end = '18:00'): WorkingHoursDay => ({
  enabled,
  start,
  end,
});

export const DEFAULT_WORKING_HOURS: WorkingHoursConfig = {
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/New_York',
  schedule: {
    monday: defaultDay(true),
    tuesday: defaultDay(true),
    wednesday: defaultDay(true),
    thursday: defaultDay(true),
    friday: defaultDay(true),
    saturday: defaultDay(false),
    sunday: defaultDay(false),
  },
};

/** Used until contractor saves working hours — keeps Save enabled on first visit */
export const UNSAVED_WORKING_HOURS: WorkingHoursConfig = {
  timezone: DEFAULT_WORKING_HOURS.timezone,
  schedule: {
    monday: defaultDay(false),
    tuesday: defaultDay(false),
    wednesday: defaultDay(false),
    thursday: defaultDay(false),
    friday: defaultDay(false),
    saturday: defaultDay(false),
    sunday: defaultDay(false),
  },
};
